<template>
  <div>
    <template v-if="selectedFlag">
      <div class="cursor-pointer">
        <div class="available-action flex px-4 py-2" @click="downloadShipments()">
          <feather-icon icon="DownloadIcon" svgClasses="w-4 h-4" class="self-center"/>
          <span class="text-sm ml-2">{{ $t('Download') }} {{ `(${selected.length})` }}</span>
        </div>
      </div>
    </template>
    <template v-else>
      <vx-tooltip position="bottom" color="warning" :text="`${$t('Please select the order you want to download!')}`">
        <div class="cursor-not-allowed">
          <div class="pointer-events-none unavailable-action flex px-4 py-2">
            <feather-icon icon="DownloadIcon" svgClasses="w-4 h-4" class="self-center"/>
            <span class="text-sm ml-2">{{ $t('Download') }}</span>
          </div>
        </div>
      </vx-tooltip>
    </template>
  </div>
</template>

<script>
export default {
  name: 'DownloadTaxProfiles',
  props: ['selected'],
  data () {
    return {
      headerTitle: ['Merchant Name', 'Tax Type', 'Legal Name', 'Tax Registration Number', 'Governorate', 'City', 'Street', 'Building Number'],
      headerVal: ['merchant_name', 'tax_type', 'legal_name', 'tax_registration_number', 'governorate', 'city', 'street', 'building_number'],
      selectedFlag: false
    }
  },
  watch: {
    selected (val) {
      if (val.length !== 0) {
        this.selectedFlag = true
      } else {
        this.selectedFlag = false
      }
    }
  },
  methods: {
    downloadShipments () {
      import('@/vendor/Export2Excel').then(excel => {
        const list = this.selected
        const data = this.formatJson(this.headerVal, list)
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: 'Tax-Profiles',
          autoWidth: true
        })
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        switch (j) {
        case 'merchant_name':
          return v.merchant.name ? v.merchant.name : 'N/A'
        case 'tax_type':
          return v.company ? 'Company' : v.person ? 'Personal' : 'N/A'
        case 'legal_name':
          return v.name ? v.name : 'N/A'
        case 'tax_registration_number':
          return v.person ? (v.person.national_id || 'N/A') : v.company ? (v.company.tax_registration_number || 'N/A') : 'N/A'
        case 'governorate':
          return v.governorate ? v.governorate : 'N/A'
        case 'city':
          return v.city ? v.city : 'N/A'
        case 'street':
          return v.street ? v.street : 'N/A'
        case 'building_number':
          return v.building_number ? v.building_number : 'N/A'
        }
        return v[j] ? v[j] : 'N/A'
      }))
    }
  }
}
</script>